import { Modal, Table } from 'antd';
import PropTypes from 'prop-types';
import { CreateModalWrapper, ModalCloseBox } from '../../modules/employees/EmployeesStyle';
import { ModalCloseIcon } from '../../theme/SvgIcons';
import dayjs from 'dayjs';
import { activeStatusTag, checkPermission } from '../../utils/common_functions';
import { actionTypeEnums, apiModules, projectStatusOption } from '../../utils/constant';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HighlightText } from '../../theme/common_style';
import { useSelector } from 'react-redux';

const ProjectsListingModal = ({ open, onClose, data }) => {
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();

  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const canRead = checkPermission(apiModules.PROJECT, actionTypeEnums.READ, permissions);

  const columns = [
    {
      title: 'S.NO',
      dataIndex: 'key',
      key: 'key',
      render: (_, __, index) => index + 1
    },
    {
      title: 'Project Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, data) => {
        const handleNavigate = () => {
          navigate(`/project/details`, {
            state: { name: data?.name, id: data?.id }
          });
        };
        return canRead ? <HighlightText onClick={handleNavigate}>{name}</HighlightText> : { name };
      }
    },
    {
      title: 'Client Name',
      dataIndex: 'client',
      key: 'client',
      render: (_, record) => record?.client?.name || 'N/A'
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      render: (text) => (text ? dayjs(text).format('DD MMM, YYYY') : 'N/A')
    },
    {
      title: 'Deadline',
      dataIndex: 'deadline',
      key: 'deadline',
      render: (text) => (text ? dayjs(text).format('DD MMM, YYYY') : 'N/A')
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status, data) => {
        const handleNavigate = () => {
          navigate(`/project/details`, {
            state: { name: data?.name, id: data?.id }
          });
        };
        return activeStatusTag(projectStatusOption, 'value', status, canRead && handleNavigate);
      }
    }
  ];

  useEffect(() => {
    if (data && data.length > 0) {
      const statusPriority = {
        active: 1,
        delivered: 2,
        awaited: 3,
        disputed: 4,
        suspended: 5,
        cancelled: 6,
        deleted: 7
      };

      const sortedData = [...data].sort((a, b) => {
        const priorityA = statusPriority[a.status] || 999;
        const priorityB = statusPriority[b.status] || 999;
        return priorityA - priorityB;
      });

      setTableData(sortedData);
    } else {
      setTableData([]);
    }
  }, [data]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      width={850}
      footer={null}
      closeIcon={false}
      prefixCls="create-employees">
      <CreateModalWrapper>
        <ModalCloseBox onClick={onClose}>
          <ModalCloseIcon />
        </ModalCloseBox>
        <Table
          prefixCls="antCustomTable"
          columns={columns}
          dataSource={tableData}
          pagination={false}
        />
      </CreateModalWrapper>
    </Modal>
  );
};

ProjectsListingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object)
};

export default ProjectsListingModal;
